import React from 'react';
import dynamic from 'next/dynamic';
import { Box, Container, Typography } from '@mui/material';
import HeaderInformation from '../HeaderInformation';
import { COLOR_PURPLE } from 'styles/variables/colors';
import { useStyles } from './styles';
import LazyLoad from 'react-lazyload';
import Image from 'next/image';

const DynamicCustomLandingPage = dynamic(() => import('components/CustomLandingPage'));
const DynamicPublishedSection = dynamic(() => import('components/PublishedSection'));
const DynamicBookDemo = dynamic(() => import('components/BookDemo'));
const DynamicInstitutionsCommunication = dynamic(() =>
  import('components/InstitutionsCommunication'),
);
const DynamicCreatingScienceIllustrations = dynamic(() =>
  import('components/CreatingScienceIllustrations'),
);
const DynamicReferToAcademicInstitution = dynamic(() =>
  import('components/ReferToAcademicInstitution'),
);

export default function MedicalContent() {
  const classes = useStyles();

  return (
    <>
      <Box py={3} bgcolor={COLOR_PURPLE} height={239}>
        <Container>
          <HeaderInformation
            marginLeftPercentage={74}
            textTitle={
              <>
                For Medical <br /> Associations
              </>
            }
            textDescription={
              <>
                Get in touch with our team to offer the best science <br />
                infographic maker for your associates.
              </>
            }
          />
        </Container>
      </Box>

      <DynamicInstitutionsCommunication
        textTitle={
          <>
            The best infographic maker for <br /> scientific communication
          </>
        }
        textInformation={
          <>
            Trustworthy professionals require a certain level of accuracy when <br />
            communicating their work for the scientific community. Browse through
            <br />
            75,000+ scientifically-accurate illustrations in more than 80 study fields.
          </>
        }
        textButton="Request a Demonstration"
      />

      <DynamicCustomLandingPage
        textTitle={
          <>
            Custom landing page <br /> with email authentication
          </>
        }
        textDescription={
          <>
            Use the association's visual identity to <br />
            <b>strengthen the brand experience</b> while <br />
            protecting user data. Through domain-
            <br />
            based authentication and an assigned <br />
            account manager,{' '}
            <b>
              all users can log in
              <br />
              using their email
            </b>{' '}
            linked with the <br />
            association.
          </>
        }
        textButton="Get a Custom Experience"
      />

      <LazyLoad offset={100}>
        <Container>
          <Box py={6}>
            <Typography className={classes.primaryColor} variant="h4" component="h2" align="center">
              <b>
                Mind the Graph's trusted by researchers and <br /> professionals from 100+
                corporations worldwide
              </b>
            </Typography>

            <Box className={classes.mainBoxImages} pt={4}>
              <Image
                src="/images/logos-academics-institutions/stanford-university-icon.png"
                alt="stanford icon"
                loading="lazy"
                width={112}
                height={50}
              />

              <Image
                src="/images/logos-academics-institutions/pearson-icon.png"
                alt="pearson icon"
                loading="lazy"
                width={122}
                height={87}
              />

              <Image
                src="/images/logos-academics-institutions/ucla-health-icon.png"
                alt="ucla icon"
                loading="lazy"
                width={192}
                height={41}
              />

              <Image
                src="/images/ico_harvard.png"
                alt="harvard icon"
                loading="lazy"
                width={95}
                height={97}
              />

              <Image
                src="/images/logos-academics-institutions/abbott-icon.png"
                alt="abbott icon"
                loading="lazy"
                width={154}
                height={115}
              />

              <Image
                src="/images/logos-academics-institutions/mcgill-icon.png"
                alt="mcgill icon"
                loading="lazy"
                width={174}
                height={40}
              />
            </Box>
          </Box>
        </Container>
      </LazyLoad>

      <DynamicBookDemo />

      <Box>
        <Box pt={5}>
          <Typography className={classes.primaryColor} variant="h4" component="h2" align="center">
            <b>Mind the Graph has been cited in many journals worldwide</b>
          </Typography>
        </Box>

        <DynamicPublishedSection showTitle={false} />
      </Box>

      <Box bgcolor="#EEEEEE" py={6}>
        <DynamicCreatingScienceIllustrations textTitle="A perfect tool for students creating science illustrations" />
      </Box>

      <DynamicReferToAcademicInstitution
        textTitle="Refer Mind the Graph to your Scientific Society"
        textSubtitle={
          <>
            Refer the best science infographic maker as <br />
            an exclusive benefit to all associates
          </>
        }
        textInformation={
          <>
            Insert the person in charge's email <br />
            below and we'll get in touch
          </>
        }
      />
    </>
  );
}
